import styled from "styled-components";
import { BUTTON_HEIGHT_LARGE, DisplaySize, FONT_SIZE } from "@lhd/constants";
export const Container = styled.div<{
  $displaySize: DisplaySize;
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  width: fit-content;
  height: ${({ $displaySize }) => `${BUTTON_HEIGHT_LARGE[$displaySize]}px`};
  padding: 2px 8px;
  background: #d9dde5;
  border: none;
  box-shadow: none;
  outline: none;
  border-radius: 2px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "default")};
`;

export const Item = styled.button<{
  active: boolean;
  $displaySize: DisplaySize;
}>`
  padding: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-inline: 7px;
  border: none;
  border-radius: 2px;
  height: 100%;
  background: ${({ active }) => (active ? "#1E3665" : "transparent")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  font-weight: ${({ active }) => (active ? "600" : "400")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.6" : "1")};
  font-size: ${({ $displaySize }) => FONT_SIZE[$displaySize]};
  transition: all 0.2s ease;
  white-space: nowrap;
`;
